import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import  { Auth } from 'aws-amplify';
import { redirectToLogIn } from '../../util/util';

class Signin extends Component {

    state = {
        isSigningIn: true,
        signInFailed: false,
    };

    handleLoginClick = () => {
        redirectToLogIn();
    };

    componentDidMount(){
        Auth.currentSession()
        .then((session) => {
            console.log("SESSION", session);
            this.props.setUser(session.idToken.payload);
            this.setState({
                isSigningIn: false
            })
        })
        .catch((error) => {
            console.log(error);
            setTimeout(() => {
                Auth.currentSession()
                .then((session) => {
                    console.log("SESSION", session);
                    this.props.setUser(session.idToken.payload);
                    this.setState({
                        isSigningIn: false
                    })

                })
                .catch((error) => {
                    console.log(error);
                    setTimeout(() => {
                        Auth.currentSession()
                        .then((session) => {
                            console.log("SESSION", session);
                            this.props.setUser(session.idToken.payload);
                            this.setState({
                                isSigningIn: false
                            })

                        })
                        .catch((error) => {
                            console.log(error);
                            this.setState({
                                isSigningIn: false,
                                signInFailed: true
                            })
                        });
                    }, 3000);//second wait
                });
            }, 1000);//first wait
            
        });
    }

    render(){
        if(this.state.isSigningIn){
            return <div>Please wait while we complete your login</div>
        } else if(this.state.signInFailed) {
            return (
                <div>
                    Sign In Failed Click below to try again
                    <button onClick={this.handleLoginClick}>
                        Sign In
                    </button>
                </div>
            )
        }
        return <Redirect to="/rules"/>
    }
}

export default Signin;


// WEBPACK FOOTER //
// ./src/components/Signin/Signin.js